/* eslint-disable */
export interface IFileData {
  Metadata?: {
    AttachmentID?: number;
    FileName?: string;
    Description?: string;
    AddDate?: string;
    AddedBy?: string;
  };
  Bytes?: string;
  Data?: string;
}
